import { SeoMetaData } from '@cms-max/cms-browser-api-client'
import { Component } from '@cms-max/medicare-api-sdk'

export const fallbackSeoMetaData: SeoMetaData = {
  path: /\*/,
  component: Component.MedicareMy,
  seo: {
    en: {
      title: 'Medicare Complaint Form - Dashboard',
      description: ''
    },
    es: {
      title: 'Formulario de quejas de Medicare', // TODO: spanish content,
      description: 'Ahora usted puede presentar sus comentarios o quejas acerca de su plan de salud de Medicare o su plan de recetas médicas directamente a Medicare, utilizando el formulario que encontrará más abajo. Los Centros de Servicios de Medicare y Medicaid aprecian sus comentarios y los utilizarán para seguir mejorando la calidad del programa Medicare. Si usted tiene otros comentarios o quejas, o si su asunto es urgente, por favor lllame al 1-800-MEDICARE (1-800-633-4227). Los usuarios de TTY deben llamar al 1-877-486-2048.'
    }
  }
}
